module.exports = __webpack_public_path__ + "img/news_tit.9d5f4152.jpg";